var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFilterBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "13px",
    viewBox: "0 0 12 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icFilterBlack") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RHP-Mobile-Discover",
    transform: "translate(-64.000000, -111.000000)",
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(10.000000, 102.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(54.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter-filled-tool-symbol",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.55754642,5.7223733 C4.68462721,5.8606671 4.75439706,6.04132117 4.75439706,6.22820469 L4.75439706,11.735039 C4.75439706,12.0664582 5.15432779,12.2346534 5.39104691,12.0016595 L6.92722942,10.2412167 C7.13280129,9.9945305 7.24617729,9.87242081 7.24617729,9.62823881 L7.24617729,6.22945058 C7.24617729,6.04256706 7.31719303,5.86191299 7.44302793,5.72360673 L11.8509747,0.940647037 C12.1811356,0.581830684 11.9269865,0 11.4385851,0 L0.561964363,0 C0.0735754378,0 -0.181832036,0.580584794 0.149574735,0.940647037 L4.55754642,5.7223733 Z",
    id: "icFilterBlack"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFilterBlack);
export default __webpack_public_path__ + "static/media/icFilterBlack.10a0a2bfe41a09fc6ca7f8ef4f52e959.svg";
export { ForwardRef as ReactComponent };